import { render, staticRenderFns } from "./FinalReports.vue?vue&type=template&id=2bd0cf3e&"
import script from "./FinalReports.vue?vue&type=script&lang=js&"
export * from "./FinalReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports